module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2x"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "cit"
    }
  }), _c('em', [_vm._v("Key to Principal Works Cited")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I. Works by Martin Heidegger")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "12%"
    }
  }, [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("AED")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "88%"
    }
  }, [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Aus der Erfahrung des Denkens")]), _vm._v(". Pfullingen: G. Neske, 1947.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("EM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Einführung in die Metaphysik")]), _vm._v(". Tübingen: M. Niemeyer, 1953.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("EHD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Erläuterungen zu Hölderlins Dichtung")]), _vm._v(". Fourth, expanded edition. Frankfurt am Main: V. Klostermann, 1971.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("G")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Gelassenheit")]), _vm._v(". Pfullingen: G. Neske, 1959.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("H")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Holzwege")]), _vm._v(". Frankfurt am Main: V. Klostermann, 1950.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("Hk")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Heraklit")]), _vm._v(". With Eugen Fink. Frankfurt am Main: V. Klostermann, 1970.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("ID")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Identität und Differenz")]), _vm._v(". Pfullingen: G. Neske, 1957.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("NI, NII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Nietzsche")]), _vm._v(". Two volumes. Pfullingen: G. Neske, 1961.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("SA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Schellings Abhandlung über das Wesen der menschlichen Freiheit")]), _vm._v(" (1809). Edited by Hildegard Feick. Tübingen: M. Niemeyer, 1971.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("SB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Die Selbstbehauptung der deutschen Universität; Das Rektorat")]), _vm._v(" 1933/34"), _c('em', [_vm._v(": Tatsachen und Gedanken")]), _vm._v(". Edited by Hermann Heidegger. Frankfurt am Main: V. Klostermann, 1983.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("SG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Satz vom Grund")]), _vm._v(". Pfullingen: G. Neske, 1957.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("SZ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Sein und Zeit")]), _vm._v(". Twelfth edition. Tübingen: M. Niemeyer, 1972, a reprinting of the seventh edition, 1953. I have checked the later editions against the first edition, published in the eighth volume of the "), _c('em', [_vm._v("Jahrbuch für Philosophie und phänomenologische Forschung")]), _vm._v(", edited by Edmund Husserl. Halle a. d. S.: M. Niemeyer, 1927.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("UK")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Der Ursprung des Kunstwerkes")]), _vm._v(". Stuttgart: P. Reclam, 1960.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("US")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Unterwegs zur Sprache")]), _vm._v(". Pfullingen: G. Neske, 1959.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("VA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Vorträge und Aufsätze")]), _vm._v(". Pfullingen: G. Neske, 1954.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("VS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Vier Seminare: Le Thor")]), _vm._v(" 1966, 1968, 1969"), _c('em', [_vm._v("; Zähringen")]), _vm._v(" 1973. Edited by Curd Ochwadt. Frankfurt am Main: V. Klostermann, 1977.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("W")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Wegmarken")]), _vm._v(". Frankfurt am Main: V. Klostermann, 1967.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("WhD?")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Was heißt Denken?")]), _vm._v(" Tübingen: M. Niemeyer, 1954.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("ZK")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Zollikoner Seminare")]), _vm._v(". Edited by Medard Boss. Frankfurt am Main: V. Klostermann, 1987.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("ZSdD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Zur Sache des Denkens")]), _vm._v(". Tübingen: M. Niemeyer, 1969.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("20")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Prolegomena zur Geschichte des Zeitbegriffs")]), _vm._v(". Martin Heidegger Gesamtausgabe volume 20. Marburg lecture course, Summer Semester, 1925. Frankfurt am Main: V. Klostermann, 1979.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("24")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Die Grundprobleme der Phänomenologie")]), _vm._v(". Gesamtausgabe volume 24. Marburg lecture course, Summer Semester, 1927. Frankfurt am Main: V. Klostermann, 1975.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("26")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Metaphysische Anfangsgründe der Logik im Ausgang von Leibniz")]), _vm._v(". "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("Gesamtausgabe volume 26. Marburg lecture course, Summer Semester, 1928. Frankfurt am Main: V. Klostermann, 1978.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("29/30")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Die Grundbegriffe der Metaphysik: Welt—Endlichkeit—Einsamkeit")]), _vm._v(". Gesamtausgabe volume 29/30. Freiburg lecture course, Winter Semester, 1929–1930. Frankfurt am Main: V. Klostermann, 1983.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("39")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Hölderlins Hymnen “Germanien” und “Der Rhein")]), _vm._v(".” Gesamtausgabe volume 39. Freiburg lecture course, Winter Semester, 1934–1935. Frankfurt am Main: V. Klostermann, 1980.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("52")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Hölderlins Hymne “Andenken")]), _vm._v(".” Gesamtausgabe volume 52. Freiburg lecture course, Winter Semester, 1941–1942. Frankfurt am Main: V. Klostermann, 1982.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("53")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Hölderlins Hymne “Der Ister")]), _vm._v(".” Gesamtausgabe volume 53. Freiburg lecture course, Summer Semester, 1942. Frankfurt am Main: V. Klostermann, 1984.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("54")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Parmenides")]), _vm._v(". Gesamtausgabe volume 54. Freiburg lecture course, Winter Semester, 1942–1943. Frankfurt am Main: V. Klostermann, 1982.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("55")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Heraklit: (")]), _vm._v("1"), _c('em', [_vm._v(") Der Anfang des abendländischen Denkens; (")]), _vm._v("2"), _c('em', [_vm._v(") Logik: Heraklits Lehre vom Logos")]), _vm._v(". Gesamtausgabe volume 55. Freiburg lecture courses, Summer Semesters, 1943 and 1944. Frankfurt am Main: V. Klostermann, 1979.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("56/57")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Zur Bestimmung der Philosophie")]), _vm._v(". Gesamtausgabe volume 56/57. Early Freiburg lecture courses, War Emergency Semester, 1919, and Summer Semester, 1919. Frankfurt am Main: V. Klostermann, 1987.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("61")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Phänomenologische Interpretationen zu Aristotles: Einführung in die phänomenologische Forschung")]), _vm._v(". Gesamtausgabe volume 61. Early Freiburg lecture course, Winter Semester, 1921–1922. Frankfurt am Main: V. Klostermann, 1985.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("63")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Ontologie")]), _vm._v(" ("), _c('em', [_vm._v("Hermeneutik der Faktizität")]), _vm._v("). Gesamtausgabe volume 63. Early Freiburg lecture course, Summer Semester, 1923. Frankfurt am Main: V. Klostermann, 1988.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("65")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Beiträge zur Philosophie")]), _vm._v(" ("), _c('em', [_vm._v("Vom Ereignis")]), _vm._v("). Gesamtausgabe volume 65. From the years 1936–1938. Frankfurt am Main: V. Klostermann, 1989.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("II. English Translations of Heidegger’s Works")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "12%"
    }
  }, [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("BW")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "88%"
    }
  }, [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Basic Writings")]), _vm._v(". New York: Harper and Row, 1977.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("EGT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Early Greek Thinking")]), _vm._v(". New York: Harper and Row, 1975.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("NI, NII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_vm._v("[after the "), _c('em', [_vm._v("slash solidus")]), _vm._v("] "), _c('em', [_vm._v("Nietzsche")]), _vm._v(". Two paperback volumes, reproducing the four-volume hardbound translation. San Francisco: Harper Collins, 1991.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("III. Works by Friedrich Nietzsche are cited from the "), _c('em', [_vm._v("Kritische Studienausgabe")]), _vm._v(", 15 volumes, edited by Giorgio Colli and Mazzino Montinari. Berlin and Munich: "), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v("W. de Gruyter and Deutscher Taschenbuch Verlag, 1980. Cited as KSA, with volume and page. Nietzsche’s letters are cited from the "), _c('em', [_vm._v("Sämtliche Briefe, Kritische Studienausgabe")]), _vm._v(", 8 volumes, edited by Giorgio Colli and Mazzino Montinari. Berlin and Munich: W. de Gruyter and Deutscher Taschenbuch Verlag, 1986. Cited as KSAB, with volume and page.")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "12%"
    }
  }, [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("JGB")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "88%"
    }
  }, [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Jenseits von Gut und Böse")]), _vm._v(", 1886.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("ZGM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Zur Genealogie der Moral")]), _vm._v(", 1887.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("WM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Der Wille zur Macht: Versuch einer Umwertung aller Werte")]), _vm._v(". Edited by Peter Gast, with the assistance of Elisabeth Förster-Nietzsche. Stuttgart: A. Kröner, 1964 [the second, expanded edition of 1906, reprinted in 1930].")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("IV. Works by Sigmund Freud are cited from the "), _c('em', [_vm._v("Studienausgabe")]), _vm._v(", 11 volumes, edited by Alexander Mitscherlich, Angela Richards, and James Strachey. Frankfurt am Main: Fischer Taschenbuch Verlag, 1982. Cited as StA, with volume and page.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("V. Works by Jacques Derrida")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("Cp")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "85%"
    }
  }, [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("La Carte postale de Socrate à Freud et au-delà")]), _vm._v(". Paris: Aubier-Flammarion, 1980. "), _c('em', [_vm._v("The Post Card: From Socrates to Freud and Beyond")]), _vm._v(". Translated by Alan Bass. Chicago: University of Chicago Press, 1987.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("De")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("De l’esprit: Heidegger et la question")]), _vm._v(". Paris: Galilée, 1987. "), _c('em', [_vm._v("Of Spirit: Heidegger and the Question")]), _vm._v(". Translated by Geoff Bennington and Rachel Bowlby. Chicago: University of Chicago Press, 1989.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("Gs, I–IV")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_vm._v("The four “Geschlecht” papers: (1) and (2) are published in "), _c('em', [_vm._v("Psyché")]), _vm._v(", with English translations as follows: (1) in "), _c('em', [_vm._v("Research in Phenomenology")]), _vm._v(", XIII, 1983, 65–83; (2) translated by John P. Leavey, Jr. in "), _c('em', [_vm._v("Deconstruction and Philosophy: The Texts of Jacques Derrida")]), _vm._v(". Edited by John Sallis. Chicago: University of Chicago Press, 1987, 161–96. The third “Geschlecht” is not yet published. The fourth appears in "), _c('em', [_vm._v("Reading Heidegger: Commemorations")]), _vm._v(". Edited by John Sallis. Bloomington: Indiana University Press, 1992.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("Ma")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Marges de la philosophie")]), _vm._v(". Paris: Minuit, 1972. "), _c('em', [_vm._v("Margins of Philosophy")]), _vm._v(". Translated by Alan Bass. Chicago: University of Chicago Press, 1982.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabler"
  }, [_vm._v("Ps")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "thang"
  }, [_c('em', [_vm._v("Psyché: Inventions de l’autre")]), _vm._v(". Paris: Galilée, 1987.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24a23a9b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cit.vue
// module id = 78
// module chunks = 0